import { render, staticRenderFns } from "./customerMetric.vue?vue&type=template&id=368b57c4&"
import script from "./customerMetric.vue?vue&type=script&lang=js&"
export * from "./customerMetric.vue?vue&type=script&lang=js&"
import style0 from "./customerMetric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports